import moment from 'moment';
import { useIntl } from 'react-intl';
import styles from './ProUserProfile.module.css';
import MapComponent from './MapComponent';
import SocialLinks from './SocialLinks';
import { AvatarLarge } from '../../../components';
import { useEffect, useState } from 'react';
import basedGetUrlRequestLogedIn from '../../../util/apiRequests/basedGetUrlRequestLogedIn';

import 'moment/locale/es';
import 'moment/locale/eu';
import 'moment/locale/en-gb';

const ProfilePage = props => {
  const intl = useIntl();
  const { listings } = props || {};
  const firstListing = listings[0];
  const user = props?.user || {};
  const { attributes } = user || {};
  const [myLocation, setMyLocation] = useState({ lat: 41.3851, lng: 2.1734 });
  const [city, setCity] = useState('');
  moment.locale(intl.locale);

  const userId = user?.id?.uuid;
  useEffect(() => {
    (async () => {
      try {
        const response = await basedGetUrlRequestLogedIn(`/api/get-public-user-city/${userId}`);
        if (response) {
          setMyLocation(response.coords);
          setCity(response.city);
        } else {
          setMyLocation(myLocation);
        }
      } catch (error) {
        setMyLocation(myLocation);
      }
    })();
  }, [userId]);

  const { profile } = attributes || {};
  const { metadata } = profile || {};
  const { publicData } = profile || {};
  // Todo: Deprecate siltUserStatus.
  const { siltUserStatus } = metadata || {};
  const { roles, linkWorkVideo } = publicData || {};
  const urlObj = new URL(linkWorkVideo ? linkWorkVideo : 'https://aloka.app');

  // Use URLSearchParams to get the 'v' parameter

  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <div className={styles.memberSince}>
          {intl.formatMessage({ id: 'profilePage.memberSince' })}{' '}
          {moment(attributes?.createdAt).format('LL')}
        </div>
      </div>

      {/* Main Content */}
      <div className={styles.mainContent}>
        {/* Left Section */}
        <div className={styles.leftSection}>
          {/* Profile Info */}
          <div className={styles.profileInfo}>
            <div className={styles.profileImageContainer}>
              <AvatarLarge user={user} disableProfileLink />
            </div>
            <div className={styles.profileDetails}>
              <h1 className={styles.name}>{profile?.displayName}</h1>
              <div className={styles.socialLinks}>
                <SocialLinks publicData={attributes?.profile?.publicData} />
              </div>
            </div>
          </div>

          {/* Tags */}
          <div className={styles.tags}>
            {roles?.map(role => (
              <span className={styles.tag}>{intl.formatMessage({ id: role })}</span>
            ))}
          </div>

          {/* Description */}
          <div className={styles.description}>
            <p>{profile?.bio}</p>
          </div>

          {/* View Work Section */}
          {linkWorkVideo && (
            <div className={styles.viewWork}>
              <div className={styles.viewWorkHeader}>
                {intl.formatMessage({ id: 'profilePage.viewWork' })}
              </div>
              <div className={styles.videoPlayer}>
                {(() => {
                  let videoId = null;
                  let platform = null;

                  try {
                    const urlObj = new URL(linkWorkVideo);

                    // ✅ Check YouTube
                    if (urlObj.hostname.includes('youtube.com')) {
                      videoId = urlObj.searchParams.get('v');
                      platform = 'youtube';
                    } else if (urlObj.hostname.includes('youtu.be')) {
                      videoId = urlObj.pathname.slice(1);
                      platform = 'youtube';
                    }

                    // ✅ Check Vimeo
                    if (urlObj.hostname.includes('vimeo.com')) {
                      videoId = urlObj.pathname.split('/').pop();
                      platform = 'vimeo';
                    }
                  } catch (err) {
                    console.error('Invalid video URL:', linkWorkVideo);
                  }

                  if (platform === 'youtube' && videoId) {
                    return (
                      <iframe
                        className={styles.frame}
                        src={`https://www.youtube.com/embed/${videoId}`}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      ></iframe>
                    );
                  }

                  if (platform === 'vimeo' && videoId) {
                    return (
                      <iframe
                        className={styles.frame}
                        src={`https://player.vimeo.com/video/${videoId}`}
                        width="560"
                        // height={100%}
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                        title="Vimeo video player"
                      ></iframe>
                    );
                  }
                })()}
              </div>
            </div>
          )}
        </div>

        {/* Right Section */}
        <div className={styles.rightSection}>
          {/* Stats */}
          <div className={styles.stats}>
            <div className={styles.stat}>
              <span className={styles.statIcon}></span>
              <span>
                {' '}
                {calculateReviewPercentage(props?.reviews)}
                {intl.formatMessage({ id: 'profilePage.positiveReviews' })}
              </span>
            </div>
          </div>

          {/* Verification */}
          <div className={styles.verification}>
            <div className={styles.verificationItem}>
              {  // Todo: Deprecate siltUserStatus.
                 siltUserStatus === 'SUCCESS' && (
                <>
                  <span className={styles.checkmark}>✓</span>
                  <span>{intl.formatMessage({ id: 'profilePage.verifiedGovernmentID' })}</span>
                </>
              )}
            </div>
          </div>

          {/* Map */}
          <div className={styles.mapContainer}>
            <div className={styles.map}>
              <MapComponent city={city} location={myLocation} zoom={10} />
            </div>
            <div className={styles.location}>
              📍 {city || 'España'}
              {/* {intl.formatMessage({ id: 'profilePage.location', value: { city } })} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;

function calculateReviewPercentage(reviews) {
  if (!reviews || reviews.length === 0) return 0;

  const maxRating = 5; // Assuming the maximum rating is 5
  let totalRating = 0;

  reviews.forEach(review => {
    if (review.attributes && typeof review.attributes.rating === 'number') {
      totalRating += review.attributes.rating;
    }
  });

  const averageRating = totalRating / reviews.length;
  const percentage = (averageRating / maxRating) * 100;

  return Math.round(percentage); // Returns whole number percentage
}
